import { render, staticRenderFns } from "./examquestion.vue?vue&type=template&id=3906ede8&scoped=true"
import script from "./examquestion.vue?vue&type=script&lang=js"
export * from "./examquestion.vue?vue&type=script&lang=js"
import style0 from "./examquestion.vue?vue&type=style&index=0&id=3906ede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906ede8",
  null
  
)

export default component.exports